import {Component, EventEmitter, Injector, Input, Output, ViewChild, ViewEncapsulation} from "@angular/core";
import {BaseComponent} from "../../../ui/components/base/base.component";
import {DxAutocompleteComponent} from "devextreme-angular";
import {AtividadeNacional} from "../../../../classes/atividade.nacional";
import {AtividadeNacionalService} from "../../services/atividade.nacional.service";

@Component({
  selector: "atividade-nacional-selector",
  templateUrl: './atividade.nacional.selector.component.html',
  styleUrls: ['./atividade.nacional.selector.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AtividadeNacionalSelectorComponent extends BaseComponent {

  @ViewChild("autoCompleteComponent")
  autoCompleteComponent: DxAutocompleteComponent;

  /** Permitir limpar o conteúdo selecionado */
  @Input()
  showClearButton : boolean = true;

  @Input()
  searchEnabled: boolean = true;

  private _value: AtividadeNacional;

  get value(): AtividadeNacional {
    return this._value;
  }

  @Input()
  set value(value: AtividadeNacional) {
    this._value = value;
  }

  /**Para não precisar ficar carregando toda hora ao chamar este componente, então podemos passar
   * como parâmetro, carregando as atividades uma vez na tela que chama.*/
  @Input()
  atividadeList: AtividadeNacional[];

  @Output()
  valueChange: EventEmitter<AtividadeNacional> = new EventEmitter<AtividadeNacional>();

  placeHolderAtividade: string = "Selecione uma atividade...";

  loadingAtividades: boolean = true;

  hint: string;

  constructor(private injector: Injector,
              private atividadeNacionalService: AtividadeNacionalService,
              ) {
    super(injector);
  }

  ngOnInit() {
    if(!this.atividadeList || !this.atividadeList.length ){
      return this.of(this.atividadeNacionalService.buscar(), atividades => {
        this.atividadeList = atividades;
        this.loadingAtividades = false;
      });
    }else{
      this.loadingAtividades = false;
    }
    if(this.value!=null){
      this.hint = this.value.getDisplayValue();
    }
  }

  onSelectionChanged(atividade: any) {
    if(atividade){
      this.hint = atividade.getDisplayValue();
    }else{
      this.hint = "";
    }

    this.valueChange.emit(atividade);
  }

}
